import { INDICADOR_TIPOS, indicadorTipoLabel } from '@/pages/indicacoes/indicadorTipos'
import { STATUS_LABEL, type ReferralPublicStatus } from '@/services/referralsService'

export type IndicacaoStaffRow = {
  id: string
  nome: string
  empresa: string
  telefone?: string | null
  email?: string | null
  site?: string | null
  publicStatus: ReferralPublicStatus
  referrer?: {
    nome: string
    empresa?: string | null
    tipo?: string | null
    responsavel?: string | null
    responsavelUser?: { id: string; name: string } | null
  }
  leadInstance?: { id: string; closerId: string | null; deletedAt: string | null; status?: string | null } | null
  deal?: { etapa?: string | null } | null
}

export type IndicacaoFilters = {
  search: string
  indicador: string
  comercial: string
  tipo: string
  status: string
}

export const SEM_COMERCIAL = '__none__'

export function indicadorDaLinha(row: IndicacaoStaffRow) {
  return row.referrer?.responsavel || row.referrer?.nome || ''
}

export function comercialDaLinha(row: IndicacaoStaffRow) {
  return row.referrer?.responsavelUser?.name?.trim() || ''
}

export function filterIndicacoes(rows: IndicacaoStaffRow[], filters: IndicacaoFilters) {
  const query = filters.search.trim().toLowerCase()
  return rows.filter((row) => {
    if (filters.indicador && indicadorDaLinha(row) !== filters.indicador) return false
    if (filters.comercial === SEM_COMERCIAL && comercialDaLinha(row)) return false
    if (filters.comercial && filters.comercial !== SEM_COMERCIAL && comercialDaLinha(row) !== filters.comercial) return false
    if (filters.tipo && row.referrer?.tipo !== filters.tipo) return false
    if (filters.status && row.publicStatus !== filters.status) return false
    if (!query) return true
    return [
      row.nome,
      row.empresa,
      row.telefone,
      row.email,
      row.site,
      row.referrer?.nome,
      row.referrer?.responsavel,
      comercialDaLinha(row),
      row.referrer?.empresa,
      indicadorTipoLabel(row.referrer?.tipo),
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase()
      .includes(query)
  })
}

export function indicadorOptions(rows: IndicacaoStaffRow[]) {
  return Array.from(new Set(rows.map(indicadorDaLinha).filter(Boolean))).sort((a, b) => a.localeCompare(b, 'pt-BR'))
}

export function comercialOptions(rows: IndicacaoStaffRow[]) {
  return Array.from(new Set(rows.map(comercialDaLinha).filter(Boolean))).sort((a, b) => a.localeCompare(b, 'pt-BR'))
}

export const TIPO_FILTER_OPTIONS = INDICADOR_TIPOS.map((item) => ({ value: item.id, label: item.label }))
export const STATUS_FILTER_OPTIONS = (Object.entries(STATUS_LABEL) as [ReferralPublicStatus, string][])
  .map(([value, label]) => ({ value, label }))
